import axios from 'axios'
import {Base64} from "js-base64"
import router from "../../router/index"
import qs from "qs"

axios.defaults.timeout = 30000;
axios.defaults.baseURL = process.env.DOMAIN_ENV;
axios.defaults.transformRequest = function (data) {
    data = qs.stringify(data);
    return data;
};
axios.interceptors.request.use(
    config => {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      if (config.method === 'post') {
        if (config.data == undefined || config.data == '') config.data = {}
        config.data.keys = null;
        config.data.sign = null
        let openid = sessionStorage.getItem('token');
        let channelID = sessionStorage.getItem('appid');
        if (openid) {
          config.data.openid = openid;
        }
        if (channelID) {
          config.data.appid = channelID;
        }
      } else if (config.method === 'get') {
        if (config.params == undefined || config.params == '') config.params = {}
        config.params.keys = null;
        config.params.sign = null
        let openid = sessionStorage.getItem('token');
        let channelID = sessionStorage.getItem('appid');
        if (openid) {
          config.params.openid = openid;
        }
        if (channelID) {
          config.params.appid = channelID;
        }
      }

      return config
    },
    error => {
        return Promise.reject(error.response);
    });
axios.interceptors.response.use(
    response => {
        if (response.data.code=="-1") {
            router.push({path:'/login'})
            return false;
        }else{
            return response.data;
        }
    },
    error => {
        return Promise.reject(error.response)
    });
export default axios;



// WEBPACK FOOTER //
// ./src/config/httpConfig/http.js